import { render, staticRenderFns } from "./UserTypeSelector.vue?vue&type=template&id=5927e776&scoped=true"
import script from "./UserTypeSelector.vue?vue&type=script&lang=js"
export * from "./UserTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./UserTypeSelector.vue?vue&type=style&index=0&id=5927e776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927e776",
  null
  
)

export default component.exports